import JoinComponent from "../lib/bandung/components/Join/JoinComponent";
import { Stack, Typography } from "@mui/material";
import JoinFullSharpIcon from '@mui/icons-material/JoinFullSharp';

export default function Join () {
    return (
      <>
        <div className="login-page-wrapper w-full py-10">
          <div className="container-x mx-auto">
            <Stack alignItems={"center"}
                   justifyContent={"center"}
                   width={"100%"}
                   margin={"2em 0"}>
              <JoinComponent
                header={
                  <>
                    <img className="w-1/2 pb-4" src={`${process.env.PUBLIC_URL}/assets/images/MarketFusionLogoSVG.svg`} alt="MarketFusion Logo" />
                    {/* <JoinFullSharpIcon fontSize={"large"}/>
                    <Typography variant={"h5"}>One2Talk</Typography> */}
                    <Typography variant={"h6"}>Join Now!</Typography>
                  </>
                }
                navigateAwayPath={"/dashboard"}
              />
            </Stack>
          </div>
        </div>
      </>
    );
}
